import styled from 'styled-components';

import { groupageBackground } from 'modules/journey/card/styled';

export const StyledTag = styled.div`
  position: relative;
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}px;` : '')}
  ${(props) =>
    props.withinGroupage ? `padding-left: ${props.theme.base.gridSizes.S} !important;` : ''}

  border-radius: 0 2px 2px 0;
  color: var(--grey700);
  height: ${(props) => props.theme.base.gridSizes.M};
  background-color: var(--grey100);
  display: flex;
  align-items: center;
  padding: 0 0.4rem;

  .pill {
    top: 0;
    left: 0;
    width: ${(props) => props.theme.base.gridSizes.XS};
    height: 100%;
    position: absolute;
    border-radius: 2px 0 0 2px;
    ${groupageBackground}
  }
`;
